"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var log = __importStar(require("loglevel"));

var logger = log.getLogger('app-logger'); // TODO Make configurable via app.config.js, NODE_ENV or similiar.

logger.setLevel('DEBUG');
exports.default = logger;